import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function AutoFillIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector 2594" fill="none" stroke={color || defaultColor} strokeLinecap="round" strokeLinejoin="round" d="M7 1.8583 7 0.5"
          strokeWidth="1"></path>
    <path id="Vector 2595" fill="none" stroke={color || defaultColor} strokeLinecap="round" strokeLinejoin="round" d="m7 5.17862 0 -1.35831"
          strokeWidth="1"></path>
    <path id="Vector 2596" fill="none" stroke={color || defaultColor} strokeLinecap="round" strokeLinejoin="round" d="m7 8.46484 0 -1.32617"
          strokeWidth="1"></path>
    <path id="Vector 2593" fill="none" stroke={color || defaultColor} strokeLinecap="round" strokeLinejoin="round"
          d="M10.6473 9.97169c-0.80999 1.45081 -2.21433 2.72021 -3.16898 3.37941 -0.28926 0.1998 -0.66738 0.1998 -0.95664 0 -0.95465 -0.6592 -2.35899 -1.9286 -3.16902 -3.37941 -0.2591 -0.46406 -0.00589 -1.01283 0.51408 -1.14096C4.62083 8.64492 5.71541 8.46484 7 8.46484s2.37917 0.18008 3.1333 0.36589c0.5199 0.12813 0.7731 0.6769 0.514 1.14096Z"
          strokeWidth="1"></path>
  </SvgIcon>
}
